/**
 * SubpageSectionToggles — Toggle sections on/off for content pages (Angebot, Methoden, Über mich).
 * Mirrors the main page's section toggle pattern but for subpages.
 * Hero sections are always-on and cannot be disabled.
 */
import { subpageSectionMap } from '@/data/subpage-sections';
import type { SubpageSection } from '@/data/subpage-sections';

interface SubpageSectionTogglesProps {
  page: 'angebot' | 'methoden' | 'ueberMich';
  sections: Record<string, boolean>;
  onToggle: (key: string, enabled: boolean) => void;
}

const PAGE_SETTING_KEY: Record<string, string> = {
  angebot: 'pageAngebot',
  methoden: 'pageMethoden',
  ueberMich: 'pageUeberMich',
};

export function SubpageSectionToggles({ page, sections, onToggle }: SubpageSectionTogglesProps) {
  const defs: SubpageSection[] = subpageSectionMap[page] || [];

  if (defs.length === 0) return null;

  return (
    <div className="sidebar__section">
      <div className="sidebar__sectionHeader">
        <div className="sidebar__sectionTitle">
          <h3>Sektionen</h3>
        </div>
      </div>
      <div className="subpage-toggles">
        {defs.map((def) => {
          const isOn = def.alwaysOn || sections[def.key] !== false;
          return (
            <label
              key={def.key}
              className={`subpage-toggle ${isOn ? 'is-active' : ''} ${def.alwaysOn ? 'is-locked' : ''}`}
            >
              <span className="subpage-toggle__icon">{def.icon}</span>
              <span className="subpage-toggle__label">{def.label}</span>
              <input
                type="checkbox"
                checked={isOn}
                disabled={def.alwaysOn}
                onChange={() => {
                  if (!def.alwaysOn) {
                    onToggle(def.key, !isOn);
                  }
                }}
                className="subpage-toggle__input"
              />
              <span className="subpage-toggle__switch" />
            </label>
          );
        })}
      </div>
    </div>
  );
}
